module.exports = "<section class=\"height-100\">\n  <div style=\"height: 100%\">\n    <app-google-map></app-google-map>\n  </div>\n</section>"